<template>
  <section id="ccf">
    <div class="ccf">
      <v-container>
        <v-row>
          <div class="heading">
            <span>Comment ça fonctionne ?</span>
            <p>
              Sportopia est la premiere plateforme en Tunisie de coaching
              sportif en ligne.
            </p>
          </div>
        </v-row>
        <v-row>
          <v-col xs="6" sm="6" md="6" lg="3" class="responsive-pad">
            <router-link
              to="trainer"
              tag="div"
              style="cursor: pointer"
              class="item"
            >
              <v-icon size="30">mdi-account</v-icon>
              <span> Choisir un coach </span>
            </router-link>
          </v-col>
          <v-col xs="6" sm="6" md="6" lg="3" class="responsive-pad">
            <div class="item">
              <v-icon size="30">mdi-clipboard-text</v-icon>
              <span> Definir vos objectifs </span>
            </div>
          </v-col>
          <v-col xs="6" sm="6" md="6" lg="3" class="responsive-pad">
            <div class="item">
              <v-icon size="30">mdi-calendar-clock</v-icon>
              <span> programmer vos sessions </span>
            </div>
          </v-col>
          <v-col xs="6" sm="6" md="6" lg="3" class="responsive-pad">
            <div class="item">
              <v-icon size="30">mdi-clipboard-check</v-icon>
              <span> Suivre votre performance </span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
export default {
  name: "AppCcf",
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Lato:300,400|Poppins:300,400,800&display=swap");
@import url("./../../assets/css/main-css.css");
section {
  background: #f5f5f5;
  padding: 50px 0;
}
.ccf {
  background: #fff;
  border-radius: 40% 0% 44% 0% / 25% 10% 25% 10%;
  padding: 70px 0;
  text-align: center;
}
.ccf .heading {
  margin: 0 auto 60px auto;
}
.heading span {
  font-size: 28px;
  font-weight: 600;
  display: block;
}
.heading p {
  font-size: 16px;
  font-weight: normal;
}
.item {
  margin-bottom: 20px;
  display: inline-grid;
  transition: all 0.3s ease;
}
.item .v-icon {
  color: #fff;
  display: block;
  margin-bottom: 15px;
  transition: all 0.3s ease-in-out;
}
.item .v-icon::before {
  background: #e91e24;
  padding: 25px;
  border-radius: 50%;
  transition: all 0.3s ease;
}
.item:hover .v-icon {
  color: #e91e24;
}
.item:hover .v-icon::before {
  background: #fff;
  box-shadow: 1px 7px 10px rgba(0, 0, 0, 0.2);
}
.item span {
  transition: all 0.3s ease-in-out;
  font-size: 18px;
  font-weight: 600;
  color: #888;
}
.item:hover span {
  font-weight: 600;
  color: #e91e24;
}
.col {
  flex-basis: auto !important;
}
@media (max-width: 980px) {
  .ccf {
    border-radius: 33% 0% 33% 0% / 10% 10% 10% 10%;
  }
}
</style>